export default __webpack_public_path__ + "static/media/FKGroteskNeue-Black.cc505a1f.woff2";